import { Link } from 'react-router-dom';
import logo from '../images/Suparity_Logo.png';
import React from 'react';


const Header = () => {

    return (
    <nav className="navbar bg-body-tertiary">
        <div className="container-fluid justify-content-start">
          <Link to="/" className="navbar-brand">
            <img src={logo} alt="Logo" width="30" height="24" className="d-inline-block align-text-top" />
            Suparity
          </Link>
          <Link to="/contact" className="btn btn-outline-success me-2">Contact us</Link>
          {/* Add other navigation links here */}
        </div>
      </nav>
    );};

    export default Header